<template>
	<div class="small-12 primaryNavMenu propertiesMenu animated">
		<div class="small-12 wrap">
			<figure class="small-12 flex">properties/</figure>
			<div class="small-12 large-4 columns title">
				<div class="small-12 path">
					<h4 class="cPrimaryDark small-12">properties/</h4>
				</div>
				<div class="small-12">
					<h1 class="small-12">Properties Management</h1>
				</div>
				<div class="small-12 nav">
					<nav class="small-12 float-left">
						<ul class="small-12 flex">
							<li class="small-12" @click="closeMenu()">
								<router-link :to="{ name: 'Dashboard' }">
									Dashboard
								</router-link>
							</li>
							<li class="small-12" @click="closeMenu()">
								<router-link :to="{ name: 'PropertiesDashboard' }">
									Properties
								</router-link>
							</li>
						</ul>
					</nav>
				</div>
			</div>
			<div class="small-12 large-8 columns closeMenu flex justify-right">
				<a @click="closeMenu()">
					<i class="material-icons-outlined">clear</i>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PropertiesMenu',

		/*
		**  Set the methods
		*/

		methods: {

			openMenu: function() {

				$('.propertiesMenu').addClass('active');

			},

			closeMenu: function() {

				$('.propertiesMenu').removeClass('active');

			}
			
		}

	}

</script>